export const searchUserConstants = {
  SEARCH_USER_SUCCESS: 'SEARCH_USER_SUCCESS',
  SEARCH_USER_ERROR: 'SEARCH_USER_ERROR',
  SEARCH_USER_REQUEST: 'SEARCH_USER_REQUEST',
};
